import { render, staticRenderFns } from "./Redis.vue?vue&type=template&id=11f74d97"
import script from "./Redis.vue?vue&type=script&lang=js"
export * from "./Redis.vue?vue&type=script&lang=js"
import style0 from "./Redis.vue?vue&type=style&index=0&id=11f74d97&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports